import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const featuredCategories = categories.filter((c) => c.featured);
  const otherCategories = categories.filter((c) => !c.featured);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门视频平台
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            七大水果植物系列平台，涵盖电视剧、电影、综艺、动漫、少儿等全品类内容
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {featuredCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all cursor-pointer"
            >
              <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${cat.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${cat.icon} text-background-50 text-xl`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                {cat.description}
              </p>
              <span className="text-[10px] text-foreground-400">
                {cat.videoCount.toLocaleString()}+ 部资源
              </span>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-3">
          {otherCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 p-3 rounded-lg bg-background-100/70 border border-background-200/40 hover:border-accent-300 transition-all cursor-pointer"
            >
              <div className={`w-9 h-9 rounded-md bg-gradient-to-br ${cat.color} flex items-center justify-center shrink-0`}>
                <i className={`${cat.icon} text-background-50 text-sm`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-950">{cat.name}</h3>
                <p className="text-[10px] text-foreground-500">{cat.videoCount.toLocaleString()}+ 部</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}